import { z } from 'zod';

// Reusable function to preprocess string numbers
const preprocessStringNumber = (val: unknown): number | undefined => {
  if (typeof val === 'string') {
    if (!/^\d+(\.\d+)?$/.test(val)) {
      return NaN;
    }
    const numVal = parseInt(val, 10);
    return numVal;
  }
  return val as number | undefined;
};

// Preprocess string number to number before doing further validation
export const StringNumberSchema = z.preprocess(preprocessStringNumber, z.number()).optional();

// Reusable schema that accepts booleans and string boolean: 'true' or 'false'
export const StringBooleanSchema = z
  .union([z.boolean(), z.literal('true'), z.literal('false')])
  .transform((value) => value === true || value === 'true');
